module.exports = __webpack_public_path__ + "static/media/certificate-to-modify.fe7d5fcc.png";